export default __webpack_public_path__ + "static/media/Thai.8f2f47aa.png";